
const Waves = () => {
    return (
        <div className='box'>
            <div className='wave -one'></div>
            <div className='wave -two'></div>
            <div className='wave -three'></div>
        </div>
    )
}

export default Waves
